/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Grid } from "@mui/material";
import { FC } from "react";
import { MaterialSelector } from "./MaterialSelector";
import { IntegerTextField } from "./IntegerTextField";

export interface MaterialInputItem {
  id: number;
  quantity: number;
}
export interface MaterialInputLabel {
  id: string;
  quantity: string;
}
interface MaterialInputProps {
  label?: MaterialInputLabel;
  disabled?: boolean;
  material?: MaterialInputItem;
  onSelected?: (materialId: number) => void;
  onChangeQuantity?: (materialQuantity: number) => void;
}
export const MaterialInput: FC<MaterialInputProps> = ({
  label,
  disabled,
  material,
  onSelected,
  onChangeQuantity,
}) => {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs={8.5}>
        <MaterialSelector
          label={label?.id}
          disabled={disabled}
          materialId={material?.id}
          onSelected={onSelected}
        />
      </Grid>
      <Grid item xs={3}>
        <IntegerTextField
          label={label?.quantity}
          value={material?.quantity.toString()}
          minValue={1}
          onChanged={(text) => {
            const quantity = Number(text);
            onChangeQuantity?.(quantity);
          }}
          textFieldProps={{
            id: "filled-basic",
            variant: "outlined",
            size: "small",
            disabled: disabled,
          }}
        />
      </Grid>
    </Grid>
  );
};
